import { alpha, Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { INNER_BOTTOM_SPACE_DESK, colorsPalette, SMALL_MARGIN, MIDDLE_MARGIN } from '../../theme';

const useStyles = (background, hasMaxWidth) =>
  makeStyles((theme: Theme) =>
    createStyles({
      container: {
        paddingRight: 0,
        paddingTop: 36,
        paddingBottom: 36,
        background: theme.palette.secondary.dark,
        '&:first-child': {
          marginTop: 76,
        },
        '& .swiper-button-next,& .swiper-button-prev': {
          top: '33%',
        },

        [theme.breakpoints.up('sm')]: {
          paddingTop: 72,
          paddingBottom: 72,
          background:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,

          '& .swiper-container::after': {
            background: `transparent linear-gradient(-90deg, ${
              background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light
            } 0%, rgba(27,25,37,0) 100%) 0% 0% no-repeat padding-box`,
            height: 350,
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: -1,
            width: 50,
            zIndex: 3,
          },
        },
      },
      headingWrapper: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
      },
      heading: {
        maxWidth: 250,
        marginBottom: 22,
        [theme.breakpoints.up('sm')]: {
          maxWidth: 506,
          marginBottom: INNER_BOTTOM_SPACE_DESK,
        },
      },
      subHeading: {
        color: colorsPalette.gray,
        maxWidth: 250,
        fontSize: 16,
        marginBottom: 36,
        [theme.breakpoints.up('sm')]: {
          maxWidth: '50%',
          fontSize: 26,
        },
      },
      selectorWrapper: {
        background: colorsPalette.violetAnalyticsCard,
        padding: '5px 15px',
        borderRadius: '999em',
        marginBottom: MIDDLE_MARGIN,
        width: '100%',
      },
      selectBtnClass: {
        width: '100%',
      },
      selectHeaderClass: {
        width: '100%',
        justifyContent: 'space-between',
      },
      categoriesWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: MIDDLE_MARGIN,
        justifyContent: 'center',
      },
      categoryItem: {
        fontSize: 18,
        lineHeight: '18px',
        color: alpha(colorsPalette.white, 0.56),
        marginRight: SMALL_MARGIN,
        marginBottom: SMALL_MARGIN,
        cursor: 'pointer',
        position: 'relative',
        '&:hover': {
          color: colorsPalette.white,
          '&:after': {
            width: '100%',
          },
        },
        '&:after': {
          content: '""',
          height: 2,
          background: colorsPalette.blue,
          width: 0,
          position: 'absolute',
          bottom: -9,
          left: 0,
          transition: '0.5s ease all .3s',
        },
        '&:last-child': {
          marginRight: 0,
        },
      },
      activeCategory: {
        color: colorsPalette.white,
        '&:after': {
          width: '100%',
        },
      },
      chunkWrapper: {
        '& $itemWrapper': {
          marginRight: SMALL_MARGIN,
          '&:first-child': {
            marginBottom: MIDDLE_MARGIN,
          },
        },
      },
      itemWrapper: {
        overflow: 'hidden',
        maxWidth: hasMaxWidth ? '20%' : 'none',
        marginRight: hasMaxWidth ? '2%' : 0,
        height: 240,
        padding: '20px 0 0 0',
        [theme.breakpoints.up('md')]: {
          height: 316,
        },
      },
      pathway: {
        marginRight: 24,
      },
      item: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        textAlign: 'center',
        borderRadius: 5,
        opacity: 1,
        background: theme.palette.secondary.light,
        paddingBottom: 17,
        boxSizing: 'border-box',

        '&::after': {
          content: '""',
          display: 'block',
          position: 'absolute',
          bottom: 37,
          left: 0,
          width: '100%',
          height: 134,
          background:
            'transparent linear-gradient(0deg, #23202E 0%, #2D323800 100%) 0% 0% no-repeat padding-box',
          zIndex: 3,
        },

        [theme.breakpoints.up('sm')]: {
          '&::after': {
            display: 'none',
          },
          paddingTop: 20,
          paddingRight: 20,
        },
      },
      itemSlider: {},
      itemImgWrap: {
        width: '100%',
        position: 'relative',
        zIndex: 1,

        [theme.breakpoints.up('sm')]: {
          '&::after': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: -10,
            left: 10,
            width: '100%',
            height: '100%',
            zIndex: -1,
            border: '2px solid #4E4766',
            borderRadius: 5,
            background: theme.palette.secondary.light,
          },

          '&::before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: -20,
            left: 20,
            width: '100%',
            height: '100%',
            zIndex: -1,
            border: '2px solid #4E4766',
            borderRadius: 5,
            background: theme.palette.secondary.light,
          },
        },
      },
      itemImg: {
        width: '100%',
        height: '198px',
        overflow: 'hidden',
        objectFit: 'cover',
        borderRadius: '5px 5px 0 0',
        [theme.breakpoints.up('sm')]: {
          height: 245,
          borderRadius: 5,
        },
      },
      textWrapper: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        padding: '0 20px',
        marginTop: '-30px',
        zIndex: 4,
        [theme.breakpoints.up('sm')]: {
          marginTop: '14px',
          padding: 0,
        },
      },
      textWithIconWrapper: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      },
      itemTitle: {
        paddingTop: '-76px',
        textAlign: 'left',
        opacity: 1,
        color: colorsPalette.white,
        overflow: 'hidden',
        whiteSpace: 'inherit',
        textOverflow: 'ellipsis',
        fontWeight: 'bold',
        fontSize: 18,
        marginBottom: 7,

        [theme.breakpoints.up('sm')]: {
          fontSize: 20,
          lineHeight: '25px',
          marginBottom: 5,
        },
      },
      itemText: {
        maxWidth: 1000,
        color: colorsPalette.violet,
        overflow: 'hidden',
        whiteSpace: 'inherit',
        textOverflow: 'ellipsis',
        fontSize: 12,
        [theme.breakpoints.up('sm')]: {
          fontSize: 14,
          lineHeight: '18px',
        },
      },
      playIcon: {
        width: 11,
        height: 12,
        zIndex: 9,
        opacity: 0.7,
        [theme.breakpoints.up('sm')]: {
          display: 'none',
        },
      },
    }),
  );
export default useStyles;
